export enum MediaLibraryWorkspaceCapabilityAccessOperation {
    create = "f5ff7c77-e74f-4b02-ae03-eafeb0433a78",
    read = "e112ed3d-1055-4b56-a9dd-066cb7573e32",
    update = "23376c78-c04c-4ef7-aa67-90bcd6ae1056",
    delete = "65e8e344-a65d-4e6a-9e78-5f1b9e80955f",
}
